export default "__VITE_ASSET__D9pJH1Kt__"